<template>
  <div class="share" v-show="showShare">
    <div class="s-mask"></div>
    <div class="close" >
      <i class="iconfont icon-guanbi" @click="closeShare"></i>
    </div>
    <div class="img-wrap">
      <div class="img">
        <div class="main">
          <div></div>
        </div>
        <div class="hand">
          <div></div>
        </div>
      </div>
      <div class="text">
        <i class="iconfont icon-share"></i>点这里分享
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    showShare: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeShare() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  $s(val)
    val/750*100%
  .share{
    position fixed
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index 9999;
    .s-mask{
      position absolute
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .9)
      z-index 10000
    }
    .close{
      position absolute
      top: size(50);
      left: size(50);
      width: size(50);
      height: size(50);
      z-index 10002;
      i{
        color: #fff;
      }
    }
    .img-wrap{
      position absolute
      top: 0;
      right:0;
      z-index 10001;
      color: #fff;
      width: 100%;
      .img{
        width: 100%;
        position relative
        .main{
          position absolute;
          right: $s(70);
          margin-top: $s(14);
          width: $s(104)
          padding-bottom: $s(145);
          >div{
            position absolute;
            width: 100%;
            height: 100%;
            background-image: url('~common/image/share-01.png');
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
        .hand{
          position absolute;
          animation: hand .3s infinite
          right: $s(50);
          width: $s(51);
          padding-bottom: $s(84);
          >div{
            position absolute;
            width: 100%;
            height: 100%;
            background-image: url('~common/image/share-02.png');
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }
      .text{
        text-align right
        margin-top: $s(170)
        font-size size(30)
        padding-right: $s(50)
        i{
          font-size size(28)
        }
      }
    }
  }
  @keyframes hand {
    0%   {
      margin-top: $s(20);
    }
    100% {
      margin-top: $s(50);
    }
  }
  @-moz-keyframes hand {
    0%   {
      margin-top: $s(20);
    }
    100% {
      margin-top: $s(50);
    }
  }

  @-webkit-keyframes hand {
    0%   {
      margin-top: $s(20);
    }
    100% {
      margin-top: $s(50);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/activity/zhuli/share.vue